import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=1f1435b2&"
import script from "./screen.vue?vue&type=script&lang=js&"
export * from "./screen.vue?vue&type=script&lang=js&"
import style0 from "./screen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports